import { PRICE_TITLE, HOME_2023_TITLE } from '@/common/constants';

const routes = [
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/homeV2'),
    meta: {},
  },
  {
    path: '/2023/home',
    name: 'home2023',
    component: () => import('@/views/home2023'),
    meta: {
      title: HOME_2023_TITLE,
    },
  },
  {
    path: '/price',
    name: 'price',
    component: () => import('@/views/price/src/Index.vue'),
    meta: {
      title: PRICE_TITLE,
    },
  },
  {
    path: '/case',
    name: 'case',
    component: () => import('@/views/case/src/Index.vue'),
    meta: {},
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('@/views/help'),
    meta: {},
  },
  {
    path: '/download',
    name: 'download',
    component: () => import('@/views/download/download.vue'),
    meta: {},
  },
  {
    path: '/k12-ai-teaching',
    name: 'k12-ai-teaching',
    component: () => import('@/views/k12-ai-teaching'),
    meta: {},
  },
  {
    path: '/college-talent-training',
    name: 'college-talent-training',
    component: () => import('@/views/college-talent-training'),
    meta: {},
  },
];

export default routes;
